import React from 'react';
import { Container, Typography, Link } from '@mui/material';

function Copyright() {
  return (
    <Typography variant="body2" align="center" gutterBottom sx={{color: 'white'}}>
      {'Copyright © '}
      <Link to="#" color="inherit" href="https://dm.rs/" target="_blank">
        Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function Footer({description}) {

  return (
   
      <footer  style={{ backgroundColor: '#0d2a4a' }}>
        <Container maxWidth="lg" >
          <Typography variant="h6" align="center" gutterBottom sx={{color: 'white'}}>
            {'DM'}
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            color="textSecondary"
            component="p"
            sx={{color: 'white'}}
          >
            {description}
          </Typography>
          <Copyright />
        </Container>
      </footer>
   
  );
}

